export const table = {
  actions: "Aktionen",
  active: "Aktiv",
  author: "Autor",
  availableAt: "Verfügbar am",
  baseData: "Stammdaten",
  baseDataStructureType: "Datenstrukturtyp",
  caseIdentifier: "Case Identifier",
  className: "Klassenname",
  comment: "Kommentar",
  contentIdentifier: "Content Identifier",
  createdAt: "Erstellt am",
  createdBy: "Erstellt von",
  datetime: "Datum/Uhrzeit",
  description: "Beschreibung",
  detailsHide: "Weniger Details",
  dispatched: "Erstellt",
  end: "Ende",
  finishedAt: "Enddatum",
  id: "ID",
  initialized: "Initialisiert",
  isLocked: "Gesperrt",
  is_locked: "Gesperrt",
  label: "Bezeichnung",
  language: "Sprache",
  lastRun: "Letzter Durchlauf",
  level: "Ebene",
  logo: "Logo",
  mail: "E-Mail",
  message: "Nachricht",
  name: "Name",
  nameDisplay: "Anzeigename",
  noRecords: "Keine Datensätze gefunden",
  numberClient: "Kundennummer",
  numberPartner: "Partnernummer",
  offer: "Angebote",
  orderIndex: "Sortierindex",
  overview: "Übersicht",
  parameter: "Parameter",
  partner: "Partner",
  preview: "Vorschau",
  price: "Preise",
  primary: "Primärschlüssel",
  productNumber: "Artikel Nr.",
  progress: "Fortschritt",
  project: "Projekt",
  queue: "Queue",
  receiver: "Empfänger",
  release: "Veröffentlichung",
  reservedAt: "Reserviert am",
  role: "Rolle",
  schedule: "Zeitplan",
  sender: "Sender",
  short: "Kürzel",
  showLess: "Weniger zeigen",
  showMore: "Mehr zeigen",
  source: "Quelle",
  start: "Start",
  startedAt: "Startdatum",
  status: "Status",
  stock: "Bestand",
  subject: "Betreff",
  tableName: "Tabellenname",
  tenant: "Mandant",
  timestamp: "Zeitpunkt",
  title: "Titel",
  token: "Token",
  total: "Gesamt",
  type: "Typ",
  updatedAt: "Aktualisiert am",
  url: "URL",
  user: "Benutzer",
  uuid: "#UUID",
  value: "Wert",
  version: "Version",
  workflowComponent: "Workflow-Komponente",
  workflows: "Workflows"
};
